export const IMEI = 'IMEI';
export const SERIAL = 'SERIAL';
